module.exports = __webpack_public_path__ + "img/logo.c45f0348.png";